export default {
  1: {
    title: 'Personnel scolaire',
  },
  2: {
    title: 'Parents',
  },
  3: {
    title: 'Apprenantes et apprenants',
  },
  4: {
    title: 'Équipe conceptrice du système de l’IA',
  },
  5: {
    title: 'Équipe en informatique',
  },
  6: {
    title: 'Fournisseur externe',
  },
  7: {
    title: 'Personnel administratif',
  },
}
